import { FC, useEffect, useRef } from 'react';

import { BottomSheet } from 'components/design-system/BottomSheet';
import { Button } from 'components/design-system/Button';
import { AnyQuestionsHelper } from 'components/listing_detail/AnyQuestionsHelper';
import { RequestPricePill } from 'components/purchaseRequests/RequestPricePill';
import { RequestConditionSlideout } from 'components/purchaseRequests/Slideouts/RequestConditionSlideout';
import { minimumPriceCents } from 'consts/price';
import { useAnalytics } from 'context/analytics';
import { useModal } from 'context/modal/ModalContext';
import { usePurchaseRequest } from 'context/PurchaseRequest';
import { useHideIntercom } from 'hooks';
import { logPurchaseRequestStarted, logViewedRequestOfferRejected } from 'lib/events';
import { Model } from 'types';

export type CreateRequestBottomSheetProps = {
  onClose: () => void;
  model: Model;
  isDark?: boolean;
  price: number;
  closeModal?: () => void;
  titleText: string;
};

export const CreateRequestBottomSheet: FC<CreateRequestBottomSheetProps> = ({
  onClose,
  model,
  isDark,
  price,
  titleText,
  closeModal: closeOffersModal
}) => {
  const { closeModal, openModal } = useModal();
  const { setModel, setPrice } = usePurchaseRequest();
  const isLoggedViewedRequestOfferRejected = useRef(false);
  const analytics = useAnalytics();

  useHideIntercom();

  const openCreateRequestSlideout = () => {
    setModel(model);
    setPrice(Math.max(price, minimumPriceCents));
    closeOffersModal?.();
    logPurchaseRequestStarted(analytics, model);

    openModal(<RequestConditionSlideout closeModal={closeModal} />, true);
  };

  useEffect(() => {
    if (isLoggedViewedRequestOfferRejected.current) {
      return;
    }
    isLoggedViewedRequestOfferRejected.current = true;
    logViewedRequestOfferRejected(analytics);
  }, [analytics]);

  return (
    <BottomSheet className='pb-3 pb-md-4' onClose={onClose}>
      <div className='text-center mb-2'>
        <div className='fs-12px letter-spacing-08 opacity-60 mb-3'>{titleText}</div>
        <div className='fs-24px letter-spacing-007 mb-4'>Do you want to submit your offer to all of our sellers?</div>
        <RequestPricePill model={model} price={price} isDark={isDark} />
        <div className='opacity-60 letter-spacing-006 my-4 riforma-regular px-3'>
          We’ll show your desired price to our network of sellers and they’ll try to fill your specific request{' '}
        </div>
        <Button className='w-100 py-3 mb-3' onClick={openCreateRequestSlideout}>
          Make a request now
        </Button>
        <AnyQuestionsHelper />
      </div>
    </BottomSheet>
  );
};
